import styled from "styled-components";
import breakpoint from "../../../assets/breakpoints";

export const ContainerCard = styled.div`
flex: 1;
position: relative;
margin-left: 0;
display: flex;
flex-direction: column;
overflow-y: scroll;
margin: 2rem;
&::-webkit-scrollbar {
  display: none;
}
@media only screen and ${breakpoint.device.sm} {
  margin: 0;
}
`;
